import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

import { RankingEdit } from './RankingEdit';

export default {
    edit: RankingEdit,
    icon: EmojiEventsIcon
};
